import { DefaultError, InvalidTokenError, NetworkError } from '../constants/messages';
import history from './history';
import store from '../redux/store';
import { logoutUser } from '../redux/auth/authSlice';

const CODE_UNAUTHORIZED = 401;
const NETWORK_ERROR_MSG = 'Network Error';
const STATUS_CRITICAL_GBOEX = 'Critical';

function extractMessages(data) {
    if (!data) return [DefaultError];

    const { Mensagem, Validacoes, Tipo, errors, message, error_description } = data;

    if (Tipo === STATUS_CRITICAL_GBOEX) return [DefaultError];

    let lista = [];

    if (Validacoes && Array.isArray(Validacoes)) {
        Validacoes.forEach(({ Mensagens }) => {
            if (Array.isArray(Mensagens)) lista.push(...Mensagens);
        });
    }

    if (Mensagem) lista.push(Mensagem);
    if (message) lista.push(message);
    if (error_description) lista.push(error_description);

    if (errors && Array.isArray(errors.messages)) {
        lista.push(...errors.messages);
    }

    const unique = [...new Set(lista)].filter(Boolean);
    return unique.length > 0 ? unique : [DefaultError];
}


function createStandardError(response, messagesArray) {
    return {
        ...response,
        messages: messagesArray
    };
}

export function gboexResponse(response) {
    try {
        const { data } = response;
        if (!data || data.Status == null) return data;

        if (data.Status) {
            return { data: data.Retorno, message: extractMessages(data).join(', ') };
        }

        const messages = extractMessages(data);
        return Promise.reject(createStandardError(response, messages));
    } catch {
        return Promise.reject(createStandardError(response, [DefaultError]));
    }
};

export function gboexResponseError(error) {
    return gboexResponseErrorServicos(error);
};

// Tratar erros nas requisições de arquivos
export async function gboexResponseErrorServicos(error) {
    const { response, message: axiosMessage } = error;

    if (!response) {
        const msg = axiosMessage === NETWORK_ERROR_MSG ? NetworkError : axiosMessage || DefaultError;
        return Promise.reject({ messages: [msg] });
    }

    const { status, data } = response;

    if (status === CODE_UNAUTHORIZED) {
        store.dispatch(logoutUser({
            errors: [InvalidTokenError],
            navigate: undefined,
            history
        }));
        return Promise.reject(createStandardError(response, [InvalidTokenError]));
    }

    if (data instanceof Blob) {
        try {
            const text = await data.text();
            const json = JSON.parse(text);
            const msgs = extractMessages(json);
            return Promise.reject(createStandardError(response, msgs));
        } catch {
            return Promise.reject(createStandardError(response, [DefaultError]));
        }
    }

    const msgs = extractMessages(data);
    return Promise.reject(createStandardError(response, msgs));
};